$('#subscription-form').submit(function (e) {
    e.preventDefault();

    var email = $('#subscription-form').find('[name="email"]');

    var data = {
        phone: 'subscribe',
        name: 'subscribe',
        email: email.val(),
        comment: 'subscribe',
    };

    $.ajax({
        type: $('#subscription-form').attr('method'),
        url: $('#subscription-form').attr('action'),
        data: data,
        success: function (response) {
            if (response.result === 'success') {
                email.val('');

                $('#subscriptionSuccessMessage').fadeIn();
                setTimeout(function() {
                    $('#subscriptionSuccessMessage').fadeOut();
                }, 3000);
            } else {

                $('#subscriptionErrorMessage').fadeIn();
                setTimeout(function() {
                    $('#subscriptionErrorMessage').fadeOut();
                }, 3000);
            }
        },
        error: function (response) {
            $('#subscriptionErrorMessage').fadeIn();
            setTimeout(function() {
                $('#subscriptionErrorMessage').fadeOut();
            }, 3000);
        }
    });
});
